import * as React from 'react';

// API
import apibridge from '../../apibridge';

// UTILS
import { validationErrorsToString } from '../../utils';

// REDUX
import { useAppSelector } from '../../store';

// PACKAGES
import { Link } from 'react-router-dom';
import { SwitchTransition, CSSTransition } from 'react-transition-group';

// COMPONENTS
import CircleImage from '../../components/CircleImage';
import NoInfoMessage from '../../components/NoInfoMessage';
import LoadingSpinner from '../../components/LoadingSpinner';

// TYPES
import { VisitorsDashboardVisitor } from '../../api/models';

const Visitors: React.FC = () => {
	// Error and Loading state
	const [formErrorMessage, setFormErrorMessage] = React.useState<string>('');

	const [isLoading, setIsLoading] = React.useState<boolean>(true);

	// State to hold fetch data
	const [visitorsData, setVisitorsData] = React.useState<VisitorsDashboardVisitor[]>([]);

	const userIsAdmin = useAppSelector((state) => state.user.isOrganisationAdmin);

	const getVisitorsData = async () => {
		setIsLoading(true);

		const response = await apibridge.getVisitorsData();

		response.result = response.result || [];

		if (response.isError) {
			setIsLoading(false);

			setFormErrorMessage(
				response.validationErrors.length
					? validationErrorsToString(response.validationErrors)
					: response.message || 'An error has occurred'
			);
		} else {
			setIsLoading(false);

			setVisitorsData(response.result);
		}
	};

	React.useEffect(() => {
		getVisitorsData();
	}, []);

	const currentVisitorsData = visitorsData.filter((item) => item.isCurrentMember === true);

	return (
		<div className="page-general-layout">
			{!!formErrorMessage ? (
				<div className="form-validation-error">{formErrorMessage}</div>
			) : (
				<SwitchTransition mode="out-in">
					<CSSTransition key={`key_${isLoading}`} timeout={600} classNames="standalone-fade" mountOnEnter unmountOnExit>
						{isLoading ? (
							<LoadingSpinner show={isLoading} />
						) : (
							<>
								{userIsAdmin && currentVisitorsData && currentVisitorsData.length > 0 ? (
									<section className="info-section mtop-0">
										<div className="section-header"></div>

										<ul>
											{currentVisitorsData &&
												currentVisitorsData.length > 0 &&
												currentVisitorsData.map((item) => {
													return (
														<li key={item.id} className="row-container">
															<div className="row detail-row">
																<div className="col-auto pdl-0 pdr-0">
																	<CircleImage
																		src={item?.profileImage}
																		firstName={item?.firstName}
																		lastName={item?.lastName}
																		isProfileInComplete={item.needsAttention}
																	/>
																</div>

																<div className="col-md-auto full-width">
																	<div className="row detail-info">
																		<div className="col-lg-4 detail-name">
																			{item.firstName} {item.lastName}
																		</div>
																		{item.visitPurpose && (
																			<div className="col-lg-4 detail-status">
																				<div className="title">{item.visitPurpose}</div>

																				<div className="name color-grey-4">{item.businessName}</div>
																			</div>
																		)}
																	</div>
																</div>

																<div className="col-auto pdr-0 link-group">
																	<Link className="btn-text pdr-0" to={`visitors/${item?.id}`}>
																		View
																	</Link>
																</div>
															</div>
														</li>
													);
												})}
										</ul>
									</section>
								) : (
									<NoInfoMessage message="There are no visitors associated with your organisation." />
								)}
							</>
						)}
					</CSSTransition>
				</SwitchTransition>
			)}
		</div>
	);
};

export default Visitors;
